/* Pırlanta Rehberi: carat slider (stone on the hand and at true size) and term info boxes. */
(() => {
  const box = document.querySelector('[data-guide-carat]');
  if (box) {
    // Diameter of a well-cut round brilliant ≈ 6.5 mm × ct^(1/3).
    const range = box.querySelector('[data-guide-carat-range]');
    const carats = range.dataset.carats.split(',').map(Number);
    const lang = document.documentElement.lang || 'tr';
    const stone = box.querySelector('[data-guide-stone]');
    const trueStone = box.querySelector('[data-guide-true-stone]');
    const steps = box.querySelectorAll('[data-guide-carat-step]');
    const note = box.querySelector('[data-guide-true-note]');
    // The stone fills about half of its image (the rest is shadow), so the image is ~1.99 × the stone.
    const IMAGE_PER_STONE = 1.99;
    // Hand photo: the ring finger is ~19.7% of the photo width, taken as 17.5 mm.
    const HAND_PERCENT_PER_MM = 19.65 / 17.5;
    const diameter = (carat) => 6.5 * Math.cbrt(carat);
    let pxPerMm = 0;
    try { pxPerMm = parseFloat(localStorage.getItem('joy-px-per-mm')) || 0; } catch (error) { /* private mode */ }
    if (pxPerMm) note.textContent = note.dataset.calibrated;
    const perMm = pxPerMm || 96 / 25.4;
    // Reserve room for the largest stone so the layout never jumps while sliding.
    box.querySelector('[data-guide-true-stage]').style.minHeight = `${Math.ceil(diameter(carats[carats.length - 1]) * perMm * IMAGE_PER_STONE)}px`;
    const format = (value, digits) => value.toLocaleString(lang, { minimumFractionDigits: digits, maximumFractionDigits: digits });
    const update = () => {
      const index = Number(range.value);
      const carat = carats[index];
      const mm = diameter(carat);
      box.querySelector('[data-guide-carat-value]').textContent = `${format(carat, 2)}\u00a0ct`;
      box.querySelector('[data-guide-carat-detail]').textContent = `≈\u00a0${format(mm, 1)}\u00a0mm`;
      range.style.setProperty('--fill', index / (carats.length - 1));
      range.setAttribute('aria-valuetext', `${format(carat, 2)} ct`);
      stone.style.width = `${mm * HAND_PERCENT_PER_MM * IMAGE_PER_STONE}%`;
      trueStone.style.width = `${mm * perMm * IMAGE_PER_STONE}px`;
      steps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.guideCaratStep) === index));
    };
    range.addEventListener('input', update);
    steps.forEach((step) => step.addEventListener('click', () => {
      range.value = step.dataset.guideCaratStep;
      update();
    }));
    update();
  }

  // Alyans Rehberi: band width slider. Gram options start at 1 g per mm of width and go 3 g higher (band standard
  // 2026-10-31); our advice is as many grams as mm in 14 ayar and 1 g more in 18 ayar. The band is drawn at true size
  // with the sizer's calibration.
  const band = document.querySelector('[data-guide-band]');
  if (band) {
    const range = band.querySelector('[data-guide-band-range]');
    const widths = range.dataset.widths.split(',').map(Number);
    const steps = band.querySelectorAll('[data-guide-band-step]');
    const strip = band.querySelector('[data-guide-band-true]');
    const note = band.querySelector('[data-guide-true-note]');
    let pxPerMm = 0;
    try { pxPerMm = parseFloat(localStorage.getItem('joy-px-per-mm')) || 0; } catch (error) { /* private mode */ }
    if (pxPerMm) note.textContent = note.dataset.calibrated;
    const perMm = pxPerMm || 96 / 25.4;
    // An average ring finger seen from above, about 17 mm across, with the band around it.
    const finger = band.querySelector('[data-guide-band-finger]');
    finger.style.width = `${17 * perMm}px`;
    finger.style.height = `${44 * perMm}px`;
    const update = () => {
      const index = Number(range.value);
      const width = widths[index];
      band.querySelector('[data-guide-band-value]').textContent = `${width} mm`;
      band.querySelector('[data-guide-band-grams]').textContent = band.dataset.grams.replace('{min}', width).replace('{max}', width + 3);
      band.querySelector('[data-guide-band-advice]').textContent = band.dataset.advice.replace('{g14}', width).replace('{g18}', width + 1);
      range.style.setProperty('--fill', index / (widths.length - 1));
      range.setAttribute('aria-valuetext', `${width} mm`);
      strip.style.height = `${width * perMm}px`;
      steps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.guideBandStep) === index));
    };
    range.addEventListener('input', update);
    steps.forEach((step) => step.addEventListener('click', () => {
      range.value = step.dataset.guideBandStep;
      update();
    }));
    update();

    // The video loads when it comes near the screen and plays muted in a loop; with reduced motion it waits for a tap.
    const video = band.querySelector('[data-guide-band-video]');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = () => {
      if (video.src) return;
      video.src = video.dataset.src;
      if (still) video.controls = true;
      else video.play().catch(() => { video.controls = true; });
    };
    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        watcher.disconnect();
        load();
      }, { rootMargin: '200px' });
      watcher.observe(video);
    } else {
      load();
    }
  }

  // Terms: text links to #terim-… become small explanations on hover, focus or tap (like the trust icons).
  const guide = document.querySelector('.guide-content');
  if (!guide) return;
  // Keep the box on screen: shift it sideways and open it below the term when there is no room above.
  // Computed from layout sizes, not the box's own rectangle, which is still mid-transition when a tap
  // follows a hover (it then read as "fits" and slid back off screen).
  const place = (term) => {
    const tip = term.querySelector('.guide-term-tip');
    const rects = term.getClientRects();
    if (!rects.length) return;
    const first = rects[0];
    const last = rects[rects.length - 1];
    // A term split over two lines anchors the box as the browser does: from the first line's left edge
    // to the last line's right edge, or zero wide when that edge lies further left.
    const centre = first.left + Math.max(0, last.right - first.left) / 2;
    const width = tip.offsetWidth;
    const left = centre - width / 2;
    const edge = 12;
    const max = document.documentElement.clientWidth - edge;
    let shift = 0;
    if (left < edge) shift = edge - left;
    else if (left + width > max) shift = max - (left + width);
    tip.style.setProperty('--shift', `${shift}px`);
    const above = first.top;
    const below = window.innerHeight - last.bottom;
    term.classList.toggle('is-below', above < tip.offsetHeight + 8 + edge && below > above);
  };
  const close = (except) => guide.querySelectorAll('.guide-term.is-open').forEach((term) => {
    if (term === except) return;
    term.classList.remove('is-open');
    term.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
  });
  guide.querySelectorAll('.rte a[href^="#terim-"]').forEach((link, index) => {
    const definition = document.getElementById(link.getAttribute('href').slice(1))?.querySelector('dd');
    if (!definition) return;
    const term = document.createElement('span');
    term.className = 'guide-term';
    // An inline span (not a <button>) so the line never breaks between the term and the punctuation after it.
    const button = document.createElement('span');
    button.setAttribute('role', 'button');
    button.tabIndex = 0;
    button.className = 'guide-term-trigger';
    button.textContent = link.textContent;
    button.setAttribute('aria-expanded', 'false');
    const tip = document.createElement('span');
    tip.className = 'guide-term-tip';
    tip.id = `GuideTerm-${index}`;
    tip.setAttribute('role', 'tooltip');
    tip.textContent = definition.textContent;
    button.setAttribute('aria-describedby', tip.id);
    term.append(button, tip);
    link.replaceWith(term);
  });
  guide.querySelectorAll('.guide-term').forEach((term) => {
    const button = term.querySelector('[aria-expanded]');
    button.addEventListener('keydown', (event) => {
      if (button.tagName === 'BUTTON' || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      button.click();
    });
    term.addEventListener('pointerenter', () => place(term));
    button.addEventListener('focus', () => place(term));
    button.addEventListener('click', () => {
      const open = !term.classList.contains('is-open');
      close(term);
      term.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      if (open) place(term);
    });
  });
  document.addEventListener('click', (event) => { if (!event.target.closest('.guide-term')) close(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
})();
